export const home = '/';
export const work = '/work';
export const blog = '/blog';
export const blogPost = '/blog/:id';
export const about = '/about';
